import _ from 'underscore';
import TourProductsRepository from '@/js/common/Domain/Repository/TourProducts';
import HotelOffersRepository from '@/js/common/Domain/Repository/HotelOffers';
import RailwayToursRepository from '@/js/common/components/railwayTours/Domain/repository/RailwayTours';

import tourCriteriaJsonNewApi from '@/js/common/Domain/Hydrator/tourCriteriaJsonNewApi';
import additionalTourCriteriaJsonNewApiForTour from '@/js/common/Domain/Hydrator/tourCriteria/additionalTourCriteriaJsonNewApiForTour';
import tourCriteriaJsonHotelOffer from '@/js/common/Domain/Hydrator/tourCriteriaJsonHotelOffer';
import asyncTourCriteriaJsonHydrator from '@/js/common/Domain/Hydrator/asyncTourCriteriaJson';

import railwayToursService from '@/js/common/components/railwayTours/search/service/railwaysService';
import updateRailwayTours from '@/js/common/components/railwayTours/hotelPage/service/updateRailwayTours';

import sessionService from '../session';
import SessionStatusService from '../SessionStatus';

import hotelTourProductsService from '../hotelTourProducts';
import updateTourProducts from './services/updateTourProducts';

import hotelOffersService from '../hotelOffersService';
import updateHotelOffers from './services/updateHotelOffers';

const XHR_NOT_SENT = 0;
const XHR_IS_DONE = 4;
export default class HotelSearch {
    constructor(options = {}) {
        this.withRailway = options.withRailway ?? true;
        this.tourProductsRepository = new TourProductsRepository();
        this.hotelOffersRepository = new HotelOffersRepository();
        this.railwayToursRepository = new RailwayToursRepository();

        this.startSearchTime = null;
        this.firstCacheTime = null;
        this.searchFinishedTime = null;

        this.ajaxRequests = [];
        this.syncAjaxRequests = [];
        this.asyncAjaxRequests = [];
        this.statusTimeouts = [];
        this.globalStatusTimeouts = [];
        this.requestTimeouts = [];
        this.asyncStatus = { jobsCount: 0, jobsSuccess: 0 };
    }

    getTourProducts(getToursOptions) {
        const {
            searchUuid,
            requests,
            callback,
            additionalParams,
        } = getToursOptions;

        if (!additionalParams || !additionalParams.notClearRepository) {
            this.reset();
        }
        this.startSearchTime = (new Date()).getTime();

        _.each(requests, (request) => {
            if (!request.tourCriteria.get('hotels')?.length) {
                // TrackJS.console.log(window.appConfig?.defaultTourCriteria);
                // TrackJS.console.log(document.location.hash);
                // TrackJS.track('no hotel id for hotel request');
            }
            const cacheAjaxDataTour = {
                ...tourCriteriaJsonNewApi(request.tourCriteria),
                ...additionalTourCriteriaJsonNewApiForTour(request.tourCriteria),
            };
            const asyncAjaxData = {
                ...asyncTourCriteriaJsonHydrator(request.tourCriteria),
                ...additionalTourCriteriaJsonNewApiForTour(request.tourCriteria),
            };

            const isGroupSearch = !!asyncAjaxData?.rooms?.length;

            const cacheAjaxDataHotelOffer = tourCriteriaJsonHotelOffer(request.tourCriteria);
            const cacheAjaxDataRailwayTour = tourCriteriaJsonNewApi(request.tourCriteria);

            const afterFirstSearchRequest = {
                success: false,
            };

            cacheAjaxDataTour.searchUuid = searchUuid;
            asyncAjaxData.searchUuid = searchUuid;
            cacheAjaxDataHotelOffer.searchUuid = searchUuid;
            cacheAjaxDataRailwayTour.searchUuid = searchUuid;

            if (request.type === 'sync' || request.type === 'both' || typeof request.type === 'undefined') {
                const finalCallback = () => {
                    if (this.allAjaxAreCompleted(this.syncAjaxRequests)) {
                        if (this.startSearchTime) {
                            this.searchFinishedTime = (new Date()).getTime();
                        }
                        callback.sync(this.tourProductsRepository, {
                            startSearchTime: this.startSearchTime,
                            firstCacheTime: this.firstCacheTime,
                            searchFinishedTime: this.searchFinishedTime,
                        });
                    }
                };

                const getTourProductSync = (tourCriteriaForTourRequest) => {
                    const XHR = hotelTourProductsService(tourCriteriaForTourRequest, {
                        success: (response) => {
                            if (_.isFunction(afterFirstSearchRequest.callback)) {
                                afterFirstSearchRequest.callback();
                                afterFirstSearchRequest.success = true;
                                afterFirstSearchRequest.callback = false;
                            } else {
                                afterFirstSearchRequest.success = true;
                            }

                            updateTourProducts({
                                searchData: response.result,
                                tourCriteria: request.tourCriteria,
                                tourProductsRepository: this.tourProductsRepository,
                            });

                            if (this.startSearchTime) {
                                if (this.tourProductsRepository.length) {
                                    this.firstCacheTime = (new Date()).getTime();
                                }
                            }
                            finalCallback();
                        },
                        error: (XMLHttpRequest, textStatus, errorThrown) => {
                            if (errorThrown !== 'abort') {
                                if (_.isFunction(afterFirstSearchRequest.callback)) {
                                    afterFirstSearchRequest.callback();
                                    afterFirstSearchRequest.success = true;
                                    afterFirstSearchRequest.callback = false;
                                } else {
                                    afterFirstSearchRequest.success = true;
                                }
                                finalCallback();
                            }
                        },
                    });

                    this.syncAjaxRequests.push(XHR);
                    this.ajaxRequests.push(XHR);
                };

                const getHotelOffersSync = (tourCriteriaForTourRequest) => {
                    const XHR = hotelOffersService(tourCriteriaForTourRequest, {
                        success: (getHotelOffersResponse) => {
                            if (getHotelOffersResponse.success === true) {
                                updateHotelOffers({
                                    searchData: getHotelOffersResponse.result,
                                    tourProductsRepository: this.tourProductsRepository,
                                    hotelOffersRepository: this.hotelOffersRepository,
                                });
                            } else {
                                console.log(getHotelOffersResponse);
                            }

                            finalCallback();
                        },
                        error: (XMLHttpRequest, textStatus, errorThrown) => {
                            if (errorThrown !== 'abort') {
                                finalCallback();
                            }
                        },
                    });

                    this.syncAjaxRequests.push(XHR);
                    this.ajaxRequests.push(XHR);
                };

                const getRailwayToursSync = (tourCriteriaForTourRequest) => {
                    const XHR = railwayToursService(tourCriteriaForTourRequest, {
                        success: (getRailwayToursResponse) => {
                            if (getRailwayToursResponse.success === true) {
                                updateRailwayTours({
                                    searchData: getRailwayToursResponse.result,
                                    tourCriteria: request.tourCriteria,
                                    tourProductsRepository: this.tourProductsRepository,
                                    railwayToursRepository: this.railwayToursRepository,
                                });
                            } else {
                                console.log(getRailwayToursResponse);
                            }

                            finalCallback();
                        },
                        error: (XMLHttpRequest, textStatus, errorThrown) => {
                            if (errorThrown !== 'abort') {
                                finalCallback();
                            }
                        },
                    });

                   this.syncAjaxRequests.push(XHR);
                   this.ajaxRequests.push(XHR);
                };

                if (typeof (request.timeout) !== 'undefined') {
                    this.requestTimeouts.push(setTimeout(() => {
                        if (_.isEmpty(this.tourProductsRepository)) {
                            getTourProductSync(cacheAjaxDataTour);
                        }
                        if (_.isEmpty(this.hotelOffersRepository) && !isGroupSearch) {
                            getHotelOffersSync(cacheAjaxDataHotelOffer);
                        }

                        if (_.isEmpty(this.railwayToursRepository) && this.withRailway && !isGroupSearch) {
                            getRailwayToursSync(cacheAjaxDataRailwayTour);
                        }
                    }, request.timeout));
                } else {
                    getTourProductSync(cacheAjaxDataTour);
                    if (this.withRailway && !isGroupSearch) {
                        getRailwayToursSync(cacheAjaxDataRailwayTour);
                    }
                    if(!isGroupSearch) {
                        getHotelOffersSync(cacheAjaxDataHotelOffer);
                    }
                }
            }

            if (request.type === 'async' || request.type === 'both' || typeof request.type === 'undefined') {
                if (request.type === 'async') {
                    afterFirstSearchRequest.success = true;
                }
                const finalAsyncCallback = () => {
                    if (this.allAjaxAreCompleted(this.asyncAjaxRequests)) {
                        if (this.startSearchTime) {
                            this.searchFinishedTime = (new Date()).getTime();
                        }

                        callback.async(this.tourProductsRepository.models, {
                            startSearchTime: this.startSearchTime,
                            firstCacheTime: this.firstCacheTime,
                            searchFinishedTime: this.searchFinishedTime,
                            scannedTours: 0,
                        }, this.tourProductsRepository);
                    }
                };

                this.getTourProductsAsync({
                    cacheAjaxDataTour,
                    asyncAjaxData,
                    cacheAjaxDataHotelOffer,
                    cacheAjaxDataRailwayTour,
                }, {
                    success: (response) => {
                        updateTourProducts({
                            searchData: response.result,
                            tourCriteria: request.tourCriteria,
                            tourProductsRepository: this.tourProductsRepository,
                            hotelOffersRepository: this.hotelOffersRepository,
                        });

                        finalAsyncCallback();
                    },
                    middleRequest: (response) => {
                        const updatedTourProducts = updateTourProducts({
                            searchData: response.result,
                            tourCriteria: request.tourCriteria,
                            tourProductsRepository: this.tourProductsRepository,
                            hotelOffersRepository: this.hotelOffersRepository,
                        });

                        if (this.startSearchTime && !this.firstCacheTime && updatedTourProducts.length) {
                            this.firstCacheTime = (new Date()).getTime();
                        }

                        if (callback && callback.middleRequest) {
                            callback.middleRequest(updatedTourProducts);
                        }
                    },
                    hotelOfferMiddleRequest: {
                        success: (response) => {
                            const hotelOffers = updateHotelOffers({
                                searchData: response.result,
                                tourProductsRepository: this.tourProductsRepository,
                                hotelOffersRepository: this.hotelOffersRepository,
                            });

                            if (callback && callback.middleRequest) {
                                callback.middleRequest(hotelOffers);
                            }
                        },
                        error: () => {
                        },
                    },
                    hotelOfferFinalRequest: {
                        success: (response) => {
                            updateHotelOffers({
                                searchData: response.result,
                                tourProductsRepository: this.tourProductsRepository,
                                hotelOffersRepository: this.hotelOffersRepository,
                            });

                            finalAsyncCallback();
                        },
                        error() {
                            finalAsyncCallback();
                        },
                    },
                    railwayToursMiddleRequest: {
                        success: (response) => {
                            const railwayTours = updateRailwayTours({
                                searchData: response.result,
                                tourProductsRepository: this.tourProductsRepository,
                                railwayToursRepository: this.railwayToursRepository,
                            });

                            if (callback && callback.middleRequest) {
                                callback.middleRequest(railwayTours);
                            }
                        },
                        error: () => {
                        },
                    },
                    railwayToursFinalRequest: {
                        success: (response) => {
                            updateRailwayTours({
                                searchData: response.result,
                                tourProductsRepository: this.tourProductsRepository,
                                railwayToursRepository: this.railwayToursRepository,
                            });

                            finalAsyncCallback();
                        },
                        error: () => {
                            finalAsyncCallback();
                        },
                    },
                    error: (XMLHttpRequest, textStatus, errorThrown) => {
                        if (errorThrown !== 'abort') {
                            finalAsyncCallback();
                        }
                    },
                }, afterFirstSearchRequest);
            }
        });
    }

    reset() {
        this.abortAllAjax();
        this.clearAllTimeouts();
        this.clearRepositories();
    }

    getAsyncStatus() {
        return this.asyncStatus;
    }

    isRequestCompleted(request) {
        return request.readyState === XHR_IS_DONE || request.readyState === XHR_NOT_SENT;
    }

    allAjaxAreCompleted(requests) {
        let allAreCompleted = true;
        _.each(requests, (request) => {
            if (!this.isRequestCompleted(request)) {
                allAreCompleted = false;
            }
        });
        return allAreCompleted;
    }

    clearRepositories() {
        this.tourProductsRepository.reset();
        this.hotelOffersRepository.reset();
    }

    clearRequestTimeouts() {
        _.each(this.requestTimeouts, (requestTimeout) => {
            clearTimeout(requestTimeout);
        });
        this.requestTimeouts = [];
    }

    clearAllTimeouts() {
        _.each(this.statusTimeouts, (statusTimeout) => {
            clearTimeout(statusTimeout);
        });

        _.each(this.globalStatusTimeouts, (globalStatusTimeout) => {
            clearTimeout(globalStatusTimeout);
        });

        this.statusTimeouts = [];
        this.globalStatusTimeouts = [];

        this.clearRequestTimeouts();

        this.startSearchTime = null;
        this.firstCacheTime = null;
        this.searchFinishedTime = null;
    }

    abortAllAjax() {
        _.each(this.ajaxRequests, (ajaxRequest) => {
            if (ajaxRequest.readyState !== XHR_IS_DONE) {
                ajaxRequest.abort();
            }
        });
        this.ajaxRequests = [];
        this.syncAjaxRequests = [];
        this.asyncAjaxRequests = [];
        this.asyncStatus = { jobsCount: 0, jobsSuccess: 0 };
    }

    getTourProductsAsync(tourCriteriaForTourRequest, callback, afterFirstSearchRequest) {
        const {
            cacheAjaxDataTour,
            asyncAjaxData,
            cacheAjaxDataHotelOffer,
            cacheAjaxDataRailwayTour,
        } = tourCriteriaForTourRequest;
        const {
            searchUuid,
        } = cacheAjaxDataTour;

        const isGroupSearch = !!asyncAjaxData?.rooms?.length;

        const sessionXHR = sessionService(asyncAjaxData, {
            success: (response) => {
                const session = response.result ? response.result.id : null;
                const getSessionWrapper = () => {
                    new SessionStatusService(session, {
                        success: () => {
                            this.clearRequestTimeouts();
                            if (callback?.hotelOfferFinalRequest && !isGroupSearch) {
                                const XHR = hotelOffersService(cacheAjaxDataHotelOffer, {
                                    success: (getHotelOffersResponse) => {
                                        if (getHotelOffersResponse.success === true) {
                                            callback.hotelOfferFinalRequest.success(getHotelOffersResponse);
                                        } else {
                                            callback.hotelOfferFinalRequest.error({ result: [] });
                                        }
                                    },
                                    error: () => {
                                    },
                                });
                                this.asyncAjaxRequests.push(XHR);
                                this.ajaxRequests.push(XHR);
                            }

                            if (callback?.railwayToursFinalRequest && this.withRailway && !isGroupSearch) {
                                const XHR = railwayToursService(cacheAjaxDataRailwayTour, {
                                    success: (getTourProductsResponse) => {
                                        if (getTourProductsResponse.success === true) {
                                            callback.railwayToursFinalRequest.success(getTourProductsResponse);
                                        } else {
                                            callback.railwayToursFinalRequest.error({ result: [] });
                                        }
                                    },
                                    error: () => {
                                    },
                                });
                                this.asyncAjaxRequests.push(XHR);
                                this.ajaxRequests.push(XHR);
                            }

                            const XHR = hotelTourProductsService(cacheAjaxDataTour, {
                                success: (getTourProductsResponse) => {
                                    if (getTourProductsResponse.success === true) {
                                        callback.success(getTourProductsResponse);
                                    } else {
                                        callback.error(null, getTourProductsResponse.message, getTourProductsResponse);
                                    }
                                },
                                error: callback.error,
                            });
                            this.asyncAjaxRequests.push(XHR);
                            this.ajaxRequests.push(XHR);
                        },
                        middleRequest: () => {
                            if (callback && callback.middleRequest) {
                                const XHR = hotelTourProductsService(cacheAjaxDataTour, {
                                    success: (middleResponse) => {
                                        if (middleResponse.success === true) {
                                            callback.middleRequest(middleResponse);
                                        } else {
                                            callback.middleRequest({
                                                result: [],
                                            });
                                        }
                                    },
                                    error: () => {
                                        callback.middleRequest({
                                            result: [],
                                        });
                                    },
                                });

                                this.ajaxRequests.push(XHR);
                            }

                            if (callback?.hotelOfferMiddleRequest && !isGroupSearch) {
                                const XHR = hotelOffersService(cacheAjaxDataHotelOffer, {
                                    success: (getHotelOffersResponse) => {
                                        if (getHotelOffersResponse.success === true) {
                                            callback.hotelOfferMiddleRequest.success(getHotelOffersResponse);
                                        } else {
                                            callback.hotelOfferMiddleRequest.error({ result: [] });
                                        }
                                    },
                                    error: () => {
                                    },
                                });

                                this.ajaxRequests.push(XHR);
                            }

                            if (callback?.railwayToursMiddleRequest && this.withRailway && !isGroupSearch) {
                                const XHR = railwayToursService(cacheAjaxDataRailwayTour, {
                                    success: (getRailwayToursResponse) => {
                                        if (getRailwayToursResponse.success === true) {
                                            callback.railwayToursMiddleRequest.success(getRailwayToursResponse);
                                        } else {
                                            callback.railwayToursMiddleRequest.error({ result: [] });
                                        }
                                    },
                                    error: () => {
                                    },
                                });

                                this.ajaxRequests.push(XHR);
                            }
                            console.log('send middle request!!');
                        },
                        error: (message) => {
                            this.clearRequestTimeouts();
                            callback.error(null, message, response);
                        },
                    }, {
                        asyncAjaxRequests: this.asyncAjaxRequests,
                        ajaxRequests: this.ajaxRequests,
                        statusTimeouts: this.statusTimeouts,
                        globalStatusTimeouts: this.globalStatusTimeouts,
                        countryId: cacheAjaxDataTour.country,
                        asyncStatus: this.asyncStatus,
                        isGroupSearch: isGroupSearch,
                        middleRequestsBehavior: 'halfJobs',
                        searchUuid,
                    });
                };

                if (response.success === true && session) {
                    if (afterFirstSearchRequest.success) {
                        getSessionWrapper();
                    } else {
                        afterFirstSearchRequest.callback = getSessionWrapper;
                    }
                } else {
                    callback.error(null, response.message, response);
                }
            },
            error: callback.error,
        });

        this.ajaxRequests.push(sessionXHR);
        this.asyncAjaxRequests.push(sessionXHR);
    }
}
